module.exports = __webpack_public_path__ + "img/arrow-right-carousel.a2d065b1.svg";